//language=HTML,js
import {Modal} from 'bootstrap';
import {v4 as uuid} from 'uuid';

const fetchLink = (e) => {
    if (e.button !== 0 && e.button !== 1) {
        return;
    }
    const link = e.target.closest('[data-fetch="link"]');
    if (link) {
        const url = link.href || link.dataset.url;
        if (!url) {
            return;
        }
        e.preventDefault();
        if (e.ctrlKey || e.button === 1) {
            window.open(url);
        } else {
            window.location.href = url;
        }
    }
}

document.body.addEventListener('click', fetchLink);
document.body.addEventListener('auxclick', fetchLink);

const fetchModal = e => {
    if (e.button !== 0 && e.button !== 1) {
        return;
    }
    const link = e.target.closest('[data-fetch="modal"]');
    if (!link) {
        return;
    }
    const url = link.getAttribute('href') ?? link.dataset.url;
    if (!url) {
        return;
    }
    e.preventDefault();

    if (e.type === 'mousedown' || (e.type === 'mouseup' && e.button === 0)) {
        return;
    }

    if (e.ctrlKey || e.button === 1) {
        window.open(url);
    } else {
        e.preventDefault();

        const id = 'modal-' + uuid();
        const size = 'modal-' + (link.dataset.fetchModalSize ?? link.dataset.fetchSize ?? 'xl');
        const classes = link.dataset.fetchModalClass ?? 'modal-dialog-scrollable';

        const container = document.createElement('div');
        container.id = id;
        container.classList.add('modal', 'fade');
        container.setAttribute('tabindex', -1);
        container.setAttribute('aria-labelledby', id + 'Label');
        container.setAttribute('aria-hidden', 'true');
        container.innerHTML = `
            <div class="modal-dialog ${size} ${classes}">
                <div class="modal-content">
                    <div
                        class="d-flex justify-content-center align-items-center"
                        style="height: 70vh"
                    >
                        <div
                            class="spinner-grow"
                            style="width: 3rem;height: 3rem;"
                            role="status"
                        >
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>`;
        document.body.appendChild(container);
        container.addEventListener('hidden.bs.modal', () => container.remove());

        const modal = new Modal(container, {focus: false});
        modal.show();

        fetch(url, {
            headers: {
                "X-Requested-With": "XMLHttpRequest",
                "X-Layout": "modal"
            }
        })
            .then(r => r.text())
            .then(content => {
                //check if the container still exists
                if (!document.getElementById(id)) {
                    alert('The modal was closed before the content was loaded.');
                    return;
                }

                container.firstElementChild.innerHTML = content;

                const scripts = container.getElementsByTagName('script');
                for (let i = 0; i < scripts.length; i++) {
                    const script = scripts[i];
                    const newScript = document.createElement('script');

                    // Copy all attributes.
                    for (let j = 0; j < script.attributes.length; j++) {
                        const attr = script.attributes[j];
                        newScript.setAttribute(attr.name, attr.value);
                    }

                    // Copy the script's content.
                    newScript.appendChild(document.createTextNode(script.innerHTML));

                    // Replace the old script tag with the new one.
                    script.parentNode.replaceChild(newScript, script);
                }

            });
    }
};

document.fetchModal = fetchModal;
document.fetchLink = fetchLink;

document.addEventListener('click', fetchModal);
document.addEventListener('mousedown', fetchModal);
document.addEventListener('mouseup', fetchModal);



